import React from 'react'

export const useConfetti = () => {
  const confettiRef = React.useRef(null)

  function createConfetti(particleRatio, { origin, ...rest }) {
    if (!confettiRef.current) return

    confettiRef.current({
      gravity: 0.7,
      ticks: 400,
      ...rest,
      origin: { y: 0.5, ...origin },
      particleCount: Math.floor(300 * particleRatio),
      disableForReducedMotion: true
    })
  }

  function fireConfetti(angle = 90, origin = {}) {
    createConfetti(0.25, {
      angle,
      origin,
      spread: 26,
      startVelocity: 55
    })

    createConfetti(0.2, {
      angle,
      origin,
      spread: 60
    })

    createConfetti(0.35, {
      angle,
      origin,
      spread: 100,
      decay: 0.91,
      scalar: 0.8
    })

    createConfetti(0.1, {
      angle,
      origin,
      spread: 120,
      startVelocity: 25,
      decay: 0.92,
      scalar: 1.2
    })

    createConfetti(0.1, {
      angle,
      origin,
      spread: 120,
      startVelocity: 45
    })
  }

  return { confettiRef, fireConfetti, createConfetti }
}
